import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadFileService {
  shareUrlId: any;
  constructor(private http: HttpClient) {
    //
  }

  downloadView(mapId: any, share: any, body: any) {
    body.map_id = mapId;
    body.share_id = share;
    return this.http.put<any>('/data/download-view/', body);
  }
}
